import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Main from "./main/index";
import Maintenance from './Maintenance/index'
import FcModule from './FC/index'
import FisModule from './FIS/index'
import CXC from './CXC/index'
import CXP from './CXP'
import FAC from './FAC'
import BANK from './Bank'
import UC from './UC'
import customViews from './customViews'
import { useLocation, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import AssetsModule from "./Assets";
import PointOfSale from "./PointOfSale"
import { DeviceIP } from "../util/DaFrameword";
import { GetDeviceIP } from "../appRedux/actions";

const flattenModules = data => data.flatMap(module =>
  (module.imrTabsInterfaces || []).flatMap(tab =>
    (tab.moduleInterfaces || []).map((iface, ifaceIndex) => {
      const isFirstInterface = ifaceIndex === 0;

      return {
        moduleId: isFirstInterface ? module.moduleId : "",
        moduleDisplay: isFirstInterface ? module.moduleDisplay : "",
        abreviation: isFirstInterface ? module.abreviation : "",
        tabId: isFirstInterface ? tab.tabId : "",
        tabsDisplay: isFirstInterface ? tab.tabsDisplay : "",
        interfaceId: iface.id,
        displayInterface: iface.displayInterface,
        url: iface.url,
        interfaceOrder: iface.interfaceOrder,
        interfaceType: iface.interfaceType,
        accessId: iface.accessId,
        hasAccess: iface.hasAccess,
        generateDocument: iface.generateDocument,
        active: iface.active,
        selected: false
      };
    })
  )
);

const App = ({ match }) => {

  const dispatch = useDispatch()
  const location = useLocation();
  const history = useHistory()
  const navBarItems = useSelector(({ settings }) => settings.NavBarItems);

  useEffect(() => {
    DeviceIP()
      .then(ip => dispatch(GetDeviceIP(ip)))
      .catch(error => console.error('Failed to fetch IP:', error));
  }, [dispatch]);

  useEffect(() => {
    const pathname = location.pathname;
    //Validar que la ruta a la que se intenta acceder este dentro de las rutas del usuario, esto para evitar que el usuario pueda acceder a rutas escribiendo la URL
    //if (search.trim() !== "" && navBarItems.length > 0) {
    const interfaces = flattenModules(navBarItems ?? []);
    const hasAccess = interfaces.some(i => typeof i.url === 'string' && i.url.trim() === pathname.trim());
    const allowedurls = ["/", "/EP/ErrorPages/error-401", "/EP/ErrorPages/error-404", "/EP/ErrorPages/error-500", "/Maintenance/Main"]
    if (hasAccess
      || allowedurls.includes(pathname)
      || pathname.includes("/main/dashboard/crypto")
      || pathname.includes("/Maintenance")
      || pathname.includes("/UC/Entry/CompanyCreate")
      || navBarItems == null
      || pathname.includes("/PointOfSale/Entry/PointOfSale02")
    ) {
      //console.log("Tiene acceso a la ruta")
    } else {
      //console.log("No tiene acceso a la ruta, redirigiendo a error 401")
      history.push(`${match.url}EP/ErrorPages/error-401`);
    }
  }, [history, location.pathname, match.url, navBarItems])




  return <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}main`} component={Main} />
      <Route path={`${match.url}FC`} component={FcModule} />
      <Route path={`${match.url}FIS`} component={FisModule} />
      <Route path={`${match.url}CXC`} component={CXC} />
      <Route path={`${match.url}CXP`} component={CXP} />
      <Route path={`${match.url}FAC`} component={FAC} />
      <Route path={`${match.url}Maintenance`} component={Maintenance} />
      <Route path={`${match.url}Bank`} component={BANK} />
      <Route path={`${match.url}UC`} component={UC} />
      <Route path={`${match.url}EP`} component={customViews} />
      <Route path={`${match.url}Assets`} component={AssetsModule} />
      <Route path={`${match.url}PointOfSale`} component={PointOfSale}></Route>
    </Switch>

  </div>
};
export default App;
